import NAME from "./constants";

export const getRows = store => store[NAME].rows;
export const getTableTypes = store => store[NAME].tableTypes;
export const getLoading = store => store[NAME].loading;